import { useParams } from 'react-router-dom'
import {
    AdjustmentCard,
    BalanceTiles,
    CodeCard,
    CodesCard,
    ConnectCard,
    FinalPayoutCard,
    NotesCard,
    RateHistoryCard,
    RatesCard,
    StatusCard,
    TermsCard,
} from 'src/components/admin-affiliates/DetailCards'
import { DetailTables } from 'src/components/admin-affiliates/DetailTables'
import { ApplicationDetails, InlineLink, userLabel } from 'src/components/admin-affiliates/shared'
import { AffiliateStatusBadge, errorMessage } from 'src/components/affiliate/labels'
import { Card, CardTitle, ErrorText, Grid, InlineSpinner, Muted, Page, PageTitle, Row } from 'src/components/affiliate/ui'
import { useAdminAffiliate } from 'src/hooks/useAdminAffiliates'
import { formatDay } from 'src/utils/affiliateFormat'

const sourceLabel = { application: 'by applying', invite: 'from an invite', admin: 'when an admin added them' } as const

const AdminAffiliateDetailPage = () => {
    const { affiliateId } = useParams<{ affiliateId: string }>()
    const { data: affiliate, isLoading, error } = useAdminAffiliate(affiliateId)

    return (
        <Page>
            <InlineLink to="/admin/affiliates">← All affiliates</InlineLink>
            {error ? (
                <ErrorText>{errorMessage(error)}</ErrorText>
            ) : isLoading || !affiliate ? (
                <InlineSpinner />
            ) : (
                <div key={affiliate.id} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                    <div>
                        <Row>
                            <PageTitle style={{ overflowWrap: 'anywhere' }}>{affiliate.code}</PageTitle>
                            <AffiliateStatusBadge status={affiliate.status} />
                        </Row>
                        <Muted style={{ overflowWrap: 'anywhere' }}>
                            {userLabel(affiliate.user)}
                        </Muted>
                        <Muted>
                            Joined {formatDay(affiliate.createdAt)} {sourceLabel[affiliate.source]}
                        </Muted>
                    </div>

                    <BalanceTiles affiliate={affiliate} />

                    {affiliate.status === 'terminated' && affiliate.terminationReason !== 'fraud' && (
                        <FinalPayoutCard affiliate={affiliate} />
                    )}

                    <Grid $min={280}>
                        <StatusCard affiliate={affiliate} />
                        <RatesCard affiliate={affiliate} />
                    </Grid>

                    <RateHistoryCard affiliate={affiliate} />

                    <CodesCard affiliate={affiliate} />

                    <Grid $min={280}>
                        <CodeCard affiliate={affiliate} />
                        <NotesCard affiliate={affiliate} />
                        <TermsCard affiliate={affiliate} />
                        <ConnectCard affiliate={affiliate} />
                    </Grid>

                    {affiliate.application && (
                        <Card>
                            <CardTitle>Application</CardTitle>
                            <ApplicationDetails application={affiliate.application} />
                        </Card>
                    )}

                    <AdjustmentCard affiliate={affiliate} />

                    <DetailTables affiliateId={affiliate.id} />
                </div>
            )}
        </Page>
    )
}

export default AdminAffiliateDetailPage
